<template>
    <div class="loader-overlay">
        <div class="spinner"></div>
    </div>
</template>

<script>
export default {
    name: 'LoaderOverlay'
};
</script>
